'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('@ali/prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./index.styl');

require('@ali/suitui');

require('./style.styl');

var _lange = require('./components/lange');

var _lange2 = _interopRequireDefault(_lange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// 自适应支持

// import { addSlash } from './components/utils/index';


// const isClient = (typeof window !== 'undefined');
// const logger = isClient ? require('@ali/log') : {};

// 注意：本地开发进行引用时，如下代码会覆盖本地项目的 window.__intl__，发布时注意注释掉如下代码
// if (isClient) {
//   if (module.hot) {
//     window.__BROCCOLI_SERVER_INFO__ = Object.assign({}, window.__BROCCOLI_SERVER_INFO__, {
//       timestamp: new Date().getTime(),
//     });
//     window.__BROCCOLI_CONFIG__ = Object.assign({}, window.__BROCCOLI_CONFIG__, {
//       startTime: '2017/10/10 10:10:10',
//       endTime: '2019/10/10 10:10:10',
//       profileEditDeadline: '2019/10/10 10:10:10',
//       country: 'IN',
//     });
//     // 开发插入本地语言包
//     const text = require('../config/locales/en.json');
//     window.__BROCCOLI_EXT_CONFIG__ = Object.assign({}, window.__BROCCOLI_EXT_CONFIG__, {
//       __intl__: {
//         locale: text.locale,
//         messages: text,
//       },
//     });
//     // 设置前缀
//     logger.prefix = addSlash('http://log-collect1.test.uae-2.uctest.local/logCollect/');
//   }

// }

var Index = function (_Component) {
  _inherits(Index, _Component);

  function Index() {
    _classCallCheck(this, Index);

    return _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).apply(this, arguments));
  }

  _createClass(Index, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_lange2.default, this.props);
    }
  }]);

  return Index;
}(_react.Component);

Index.propTypes = {

  /**
   * @title 页面展示的语言文案巴别塔key
   * @required
   * @description 必填
   */
  tabListKey: _propTypes2.default.string,
  /**
   * @title 背景色
   * @description 选填
   */
  bgColor: _propTypes2.default.string,
  /**
   * @title 选中背景色
   * @description 选填
   */
  selectBgColor: _propTypes2.default.string,
  /**
   * @title 按钮背景图
   * @description 选填
   */
  btnBgImg: _propTypes2.default.imgUrlString,
  /**
   * @title 按钮左边距离
   * @description 选填
   */
  left: _propTypes2.default.number,
  /**
   * @title 按钮上方距离
   * @description 选填
   */
  top: _propTypes2.default.number,
  /**
   * @title 按钮样式
   * @description 选填
   */
  btnStyle: _propTypes2.default.styleObject,
  /**
   * @title 展开列表样式
   * @description 选填
   */
  listStyle: _propTypes2.default.styleObject,
  /**
   * @title 展开列表样式
   * @description 选填
   */
  hideList: _propTypes2.default.bool
};
Index.defaultProps = {
  container: true,
  bgColor: '#0b2c58',
  selectBgColor: '#032048',
  tabListKey: 'lange_switch.lange',
  btnBgImg: '',
  hideList: true
};
exports.default = Index;